import { feeAmountTypeLabels } from "@/constant/Payment/fee-amount-type";
import { feeEntityLabels } from "@/constant/Payment/fee-entity";

export const columns = () => {
  return [
    {
      id: "entity_type",
      accessorFn: (row) => feeEntityLabels[row.entity_type],
      header: "Fee Party",
    },
    {
      id: "amount_type",
      accessorFn: (row) => feeAmountTypeLabels[row.amount_type],
      header: "Fee Type",
    },
    {
      id: "amount",
      header: "Rate",
      cell: ({ row }) => {
        let rate = row.original.amount_type.toLowerCase() === 'fixed' ? row.original.amount : row.original.amount + '%';
        return <div className={"text-right"}>{rate}</div>
      },
    },
    {
      accessorKey: "currency_code",
      header: "Currency",
    },
  ];
};
